import axios from "axios";
import React, { useEffect, useContext, useState } from "react";
import UserDataContext from "../../context/UserDataContext";
import { Link } from "react-router-dom";
import { translate } from "../../translations";
import { useHistory } from "react-router-dom";

function AppSettings() {
  const [recordData, setRecordData] = useState({});
  const history = useHistory();
  const token = localStorage.getItem("token");
  const project = localStorage.getItem("currentProjectID");
  const { userData } = useContext(UserDataContext);
  const [payload, setPayload] = useState({});
  const [success, setSuccess] = useState(false);
  const [executeAutoOrder, setExecuteAutoOrder] = useState({
    date: "",
  });
  const [updateProjectName, setUpdateProjectName] = useState(
    localStorage.getItem("currentProjectName")
  );

  async function getData() {
    const getSettings = await axios.get(
      `${process.env.REACT_APP_BACKEND}/settings/appSettings/${project}`,
      {
        headers: {
          jwttoken: token,
        },
      }
    );

    setPayload(
      getSettings.data[0]
        ? getSettings.data[0].value
        : {
            enableQRCode: false,
            enableAttachments: false,
          }
    );
  }

  async function autoOrderExecute(e) {
    e.preventDefault();
    let payload = { date: executeAutoOrder.date, autoOrders: [] };

    const projectAutoOrders = await axios.get(
      `${process.env.REACT_APP_BACKEND}/services/auto-order/get-all/${project}`,
      {
        headers: {
          jwttoken: token,
        },
      }
    );

    projectAutoOrders.data.forEach((ao) => {
      payload.autoOrders.push(ao._id);
    });

    await axios.post(
      `${process.env.REACT_APP_BACKEND}/services/auto-order/execute`,
      payload,
      {
        headers: {
          jwttoken: token,
        },
      }
    );
    setExecuteAutoOrder({ date: "", open: false });
    history.go(0);
  }

  async function updateName(e) {
    e.preventDefault();
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND}/settings/project/${project}`,
        { updateProjectName },
        {
          headers: {
            jwttoken: token,
          },
        }
      );
      setSuccess(true);
      localStorage.setItem("currentProjectName", updateProjectName);
      history.go(0);
      setTimeout(() => {
        setSuccess(false);
        history.go(0);
      }, 2000);
    } catch (err) {
      console.log(err);
    }
  }

  async function register(e) {
    e.preventDefault();
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND}/settings/appSettings/${project}`,
        payload,
        {
          headers: {
            jwttoken: token,
          },
        }
      );
      setSuccess(true);
      setTimeout(() => {
        setSuccess(false);
      }, 4000);
    } catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    getData();
  }, [userData]);

  return (
    <>
      <div className="bg-white shadow overflow-hidden sm:rounded-lg flex justify-center">
        <div className="px-4 py-5 sm:px-6 justify-start lg:w-0 lg:flex-1">
          <h3 className="text-lg leading-6 font-medium text-gray-900">
            Projekt Einstellungen
          </h3>
        </div>
      </div>
      <div className="bg-white overflow-hidden sm:rounded-lg flex justify-center my-5">
        <div className="container flex justify-start w-full">
          <div className="flex flex-col grow">
            <div class="grid grid-cols-4 gap-4">
              <div class="col-span-3">
                <div className="flex flex-col grow">
                  <div className="border-b border-gray-200 shadow overflow-hidden sm:rounded-lg">
                    <div className=" px-4 py-3 bg-gray-50 sm:px-6">
                      Schnelleinstellungen
                    </div>
                    <form onSubmit={register}>
                      <div className="shadow overflow-hidden sm:rounded-md">
                        <div className="px-4 py-5 bg-white sm:p-6">
                          <div className="grid grid-cols-6 gap-6">
                            <div className="col-span-2">
                              <label class="inline-flex items-center cursor-pointer">
                                <input
                                  type="checkbox"
                                  checked={payload.enableQRCode}
                                  class="sr-only peer"
                                  onChange={(e) =>
                                    setPayload({
                                      ...payload,
                                      enableQRCode: e.target.checked,
                                    })
                                  }
                                />
                                <div class="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                                <span class="ms-3 text-sm font-medium text-gray-700">
                                  QR-Code aktivieren
                                </span>
                              </label>
                            </div>
                            <div className="col-span-2">
                              <label class="inline-flex items-center cursor-pointer">
                                <input
                                  type="checkbox"
                                  checked={payload.enableAttachments}
                                  class="sr-only peer"
                                  onChange={(e) =>
                                    setPayload({
                                      ...payload,
                                      enableAttachments: e.target.checked,
                                    })
                                  }
                                />
                                <div class="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                                <span class="ms-3 text-sm font-medium text-gray-700">
                                  Dateianhänge aktivieren
                                </span>
                              </label>
                            </div>
                            <div className="col-span-2">
                              <label class="inline-flex items-center cursor-pointer">
                                <span class="ms-3 text-sm font-medium text-gray-700">
                                  Bundesland
                                </span>
                              </label>
                              <select
                                required="true"
                                onChange={(e) =>
                                  setPayload({
                                    ...payload,
                                    bundesland: e.target.value,
                                  })
                                }
                                value={payload.bundesland}
                                className="mt-1 pl-3 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                              >
                                <option value="BW">Baden-Württemberg</option>
                                <option value="BY">Bayern</option>
                                <option value="BE">Berlin</option>
                                <option value="BB">Brandenburg</option>
                                <option value="HB">Bremen</option>
                                <option value="HE">Hessen</option>
                                <option value="BY">
                                  Mecklenburg-Vorpommern
                                </option>
                                <option value="HH">Hamburg</option>
                                <option value="NI">Niedersachsen</option>
                                <option value="NW">Nordrhein-Westfalen</option>
                                <option value="RP">Rheinland-Pfalz</option>
                                <option value="SL">Saarland</option>
                                <option value="SN">Sachsen</option>
                                <option value="ST">Sachsen-Anhalt</option>
                                <option value="SH">Schleswig-Holstein</option>
                                <option value="TH">Thüringen</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
                          <button
                            type="submit"
                            className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                          >
                            Speichern
                          </button>
                          {success && (
                            <div
                              className="flex rounded-md items-center bg-green-500 text-white text-sm font-bold px-4 py-3 my-5"
                              role="alert"
                            >
                              <svg
                                className="fill-current w-6 h-6 mr-3"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 20 20"
                              >
                                <path d="M12.432 0c1.34 0 2.01.912 2.01 1.957 0 1.305-1.164 2.512-2.679 2.512-1.269 0-2.009-.75-1.974-1.99C9.789 1.436 10.67 0 12.432 0zM8.309 20c-1.058 0-1.833-.652-1.093-3.524l1.214-5.092c.211-.814.246-1.141 0-1.141-.317 0-1.689.562-2.502 1.117l-.528-.88c2.572-2.186 5.531-3.467 6.801-3.467 1.057 0 1.233 1.273.705 3.23l-1.391 5.352c-.246.945-.141 1.271.106 1.271.317 0 1.357-.392 2.379-1.207l.6.814C12.098 19.02 9.365 20 8.309 20z" />
                              </svg>
                              <p>
                                <p>Änderungen erfolgreich gespeichert.</p>
                              </p>
                            </div>
                          )}
                        </div>
                      </div>
                    </form>
                  </div>
                  <div className="flex flex-col mt-5 grow">
                    <div className="border-b border-gray-200 shadow overflow-hidden sm:rounded-lg">
                      <div className=" px-4 py-3 bg-gray-50 sm:px-6">
                        Projektname ändern
                      </div>
                      <form onSubmit={updateName}>
                        <div className="shadow overflow-hidden sm:rounded-md">
                          <div className="px-4 py-5 bg-white sm:p-6">
                            <div className="grid grid-cols-6 gap-6">
                              <div className="col-span-3">
                                <input
                                  required
                                  type="text"
                                  onChange={(e) =>
                                    setUpdateProjectName(e.target.value)
                                  }
                                  value={updateProjectName}
                                  className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-lg border-gray-300 rounded-md"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
                            <button
                              type="submit"
                              className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                            >
                              Speichern
                            </button>
                            {success && (
                              <div
                                className="flex rounded-md items-center bg-green-500 text-white text-sm font-bold px-4 py-3 my-5"
                                role="alert"
                              >
                                <svg
                                  className="fill-current w-6 h-6 mr-3"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 20 20"
                                >
                                  <path d="M12.432 0c1.34 0 2.01.912 2.01 1.957 0 1.305-1.164 2.512-2.679 2.512-1.269 0-2.009-.75-1.974-1.99C9.789 1.436 10.67 0 12.432 0zM8.309 20c-1.058 0-1.833-.652-1.093-3.524l1.214-5.092c.211-.814.246-1.141 0-1.141-.317 0-1.689.562-2.502 1.117l-.528-.88c2.572-2.186 5.531-3.467 6.801-3.467 1.057 0 1.233 1.273.705 3.23l-1.391 5.352c-.246.945-.141 1.271.106 1.271.317 0 1.357-.392 2.379-1.207l.6.814C12.098 19.02 9.365 20 8.309 20z" />
                                </svg>
                                <p>
                                  <p>Änderungen erfolgreich gespeichert.</p>
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                  <div className="flex flex-col mt-5 grow">
                    <div className="border-b border-gray-200 shadow overflow-hidden sm:rounded-lg">
                      <div className=" px-4 py-3 bg-gray-50 sm:px-6">
                        Automatische Bestellungen
                      </div>
                      <form onSubmit={autoOrderExecute}>
                        <div className="shadow overflow-hidden sm:rounded-md">
                          <div className="px-4 py-5 bg-white sm:p-6">
                            <div className="grid grid-cols-6 gap-6">
                              <div className="col-span-3">
                                <p className="text-sm text-gray-500">
                                  Bis zu welchem Datum sollen <b>alle</b>{" "}
                                  automatischen Bestellungen für das{" "}
                                  <b>gesamte Projekt </b>ausgeführt werden?
                                </p>
                                <input
                                  required
                                  type="date"
                                  onChange={(e) =>
                                    setExecuteAutoOrder({
                                      ...executeAutoOrder,
                                      date: e.target.value,
                                    })
                                  }
                                  value={executeAutoOrder.date}
                                  className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-lg border-gray-300 rounded-md"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
                            <button
                              type="submit"
                              className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                            >
                              Ausführen
                            </button>
                            {success && (
                              <div
                                className="flex rounded-md items-center bg-green-500 text-white text-sm font-bold px-4 py-3 my-5"
                                role="alert"
                              >
                                <svg
                                  className="fill-current w-6 h-6 mr-3"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 20 20"
                                >
                                  <path d="M12.432 0c1.34 0 2.01.912 2.01 1.957 0 1.305-1.164 2.512-2.679 2.512-1.269 0-2.009-.75-1.974-1.99C9.789 1.436 10.67 0 12.432 0zM8.309 20c-1.058 0-1.833-.652-1.093-3.524l1.214-5.092c.211-.814.246-1.141 0-1.141-.317 0-1.689.562-2.502 1.117l-.528-.88c2.572-2.186 5.531-3.467 6.801-3.467 1.057 0 1.233 1.273.705 3.23l-1.391 5.352c-.246.945-.141 1.271.106 1.271.317 0 1.357-.392 2.379-1.207l.6.814C12.098 19.02 9.365 20 8.309 20z" />
                                </svg>
                                <p>
                                  <p>Änderungen erfolgreich gespeichert.</p>
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-span-1">
                <div className="border-b border-gray-200 shadow overflow-hidden sm:rounded-lg">
                  <div className=" px-4 py-3 bg-gray-50 sm:px-6">
                    Einstellungen
                  </div>
                  <form onSubmit={register}>
                    <div className="shadow overflow-hidden sm:rounded-md">
                      <div className="px-4 py-5 bg-white sm:p-6">
                        <ul>
                          <li>
                            {" "}
                            <Link
                              to="project-users"
                              className="whitespace-nowrap inline-flex items-center justify-center px-4 py-2 border  rounded-md shadow-sm text-base font-medium my-2 border-indigo-600"
                            >
                              Benutzerverwaltung (Projekt)
                            </Link>
                          </li>
                          <li>
                            {" "}
                            <Link
                              to="edit-homescreen"
                              className="whitespace-nowrap inline-flex items-center justify-center px-4 py-2 border  rounded-md shadow-sm text-base font-medium my-2 border-indigo-600"
                            >
                              {translate("Nav_startseite-bearbeiten")}
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="service-settings"
                              className="whitespace-nowrap inline-flex items-center justify-center px-4 py-2 border  rounded-md shadow-sm text-base font-medium my-2 border-indigo-600"
                            >
                              {translate("Nav_leistungen-konfigurueren")}
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="dropdownoptions"
                              className="whitespace-nowrap inline-flex items-center justify-center px-4 py-2 border  rounded-md shadow-sm text-base font-medium my-2 border-indigo-600"
                            >
                              Auswahlfelder konfigurieren
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="translations"
                              className="whitespace-nowrap inline-flex items-center justify-center px-4 py-2 border  rounded-md shadow-sm text-base font-medium my-2 border-indigo-600"
                            >
                              {translate("Nav_uebersetzungen")}
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="import-lv"
                              className="whitespace-nowrap inline-flex items-center justify-center px-4 py-2 border  rounded-md shadow-sm text-base font-medium my-2 border-indigo-600"
                            >
                              Leistungsverzeichnis importieren
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>{" "}
    </>
  );
}

export default AppSettings;
